import { render, staticRenderFns } from "./CompanyChangeLog.vue?vue&type=template&id=66f60e82&scoped=true"
import script from "./CompanyChangeLog.vue?vue&type=script&lang=js"
export * from "./CompanyChangeLog.vue?vue&type=script&lang=js"
import style0 from "./CompanyChangeLog.vue?vue&type=style&index=0&id=66f60e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f60e82",
  null
  
)

export default component.exports